@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.footerContainer {
  position: sticky;
  bottom: -15px;
  margin: -15px;
  padding: 15px;
  background-color: var(--light-100);
  z-index: 20;
}
